/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BasicFile
 */
export interface BasicFile {
    /**
     * 
     * @type {string}
     * @memberof BasicFile
     */
    readonly path: string;
    /**
     * 
     * @type {string}
     * @memberof BasicFile
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof BasicFile
     */
    readonly size: number;
    /**
     * 
     * @type {Date}
     * @memberof BasicFile
     */
    readonly modificationTime: Date;
    /**
     * 
     * @type {number}
     * @memberof BasicFile
     */
    readonly totalSize: number;
    /**
     * 
     * @type {boolean}
     * @memberof BasicFile
     */
    readonly isDir: boolean;
    /**
     * 
     * @type {Array<object>}
     * @memberof BasicFile
     */
    files?: Array<object> | null;
}

export function BasicFileFromJSON(json: any): BasicFile {
    return BasicFileFromJSONTyped(json, false);
}

export function BasicFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): BasicFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': json['path'],
        'name': json['name'],
        'size': json['size'],
        'modificationTime': (new Date(json['modification_time'])),
        'totalSize': json['total_size'],
        'isDir': json['is_dir'],
        'files': !exists(json, 'files') ? undefined : json['files'],
    };
}

export function BasicFileToJSON(value?: BasicFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'files': value.files,
    };
}


